module.exports = __webpack_public_path__ + "static/img/coupon_one.eb3a1bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon_one.png
// module id = 5okM
// module chunks = 0